import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d8d78cd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center no-wrap" }
const _hoisted_2 = { class: "agents-nav-item show-status-bar" }
const _hoisted_3 = { class: "agents-nav-item show-status-bar show-top-dashboard" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-nowrap whitespace-nowrap items-center" }, [
  /*#__PURE__*/_createTextVNode("Show Status Bar "),
  /*#__PURE__*/_createElementVNode("i", { class: "incredi-icon incredicon-maximize !text-[20px] ml-1 -mr-1" })
], -1))

import IncrediButton from '@/components/common/incrediButton.vue';
import { useMatomo } from '@/services/matomo/matomo.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'nav-bar-show-status-bar',
  props: {
    isTopDashboardVisible: { type: Boolean }
  },
  emits: ["toggleTopDashboard"],
  setup(__props: any, { emit }: { emit: ({
  // eslint-disable-next-line no-unused-vars
  (e: 'toggleTopDashboard', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {


const matomo = useMatomo();



return (_ctx: any,_cache: any) => {
  const _component_q_separator = _resolveComponent("q-separator")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_q_separator, {
        class: "separator",
        vertical: ""
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(IncrediButton, {
        class: "table-upper-buttons text-Text/text_high border-radius-[2px] ml-3 show-status-bar-button",
        design: "master",
        "data-testid": "show-status-bar-button",
        size: "big",
        onClick: _cache[0] || (_cache[0] = 
          () => {
            emit('toggleTopDashboard', !__props.isTopDashboardVisible);
            _unref(matomo)?.trackEvent({
              category: 'Agents Page',
              action: 'Hide/Show Status Bar',
              value: 1,
            });
          }
        )
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      })
    ])
  ]))
}
}

})